const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class RevolutionaryIdea extends Action {
    constructor(age){
        super(
            age,
            ActionNames.RevolutionaryIdea,
            `Score ${RevolutionaryIdea.GetScienceAmount(age)} science.`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }

    static GetScienceAmount(age){
        switch (age)
        {
            default:
                return null;
            case Age.Age2:
                return 4;
            case Age.Age3:
                return 6;
        }
    }
}

module.exports = RevolutionaryIdea;
